import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import classnames from 'classnames';

import emptyFunction from 'common/util/emptyFunction';
import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';
import branch from 'client/core/branch';

@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrDarkModal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    userAgent: PropTypes.object.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
  };

  componentDidMount() {
    global.document.body.classList.add('overflow-hidden');
  }

  componentWillUnmount() {
    global.document.body.classList.remove('overflow-hidden');
  }

  render() {
    const { style, children, onClose, userAgent, className } = this.props;

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose || emptyFunction}
          className={classnames('darkModal', { webview: isMobileApp }, className)}
          style={style}
        >
          {children}
        </div>
      </Portal>
    );
  }
}

SrDarkModal.displayName = 'SrDarkModal';

export default SrDarkModal;
